import content from '../../../data/content.json';

export default function GapFillingSection() {
  return (
    <section id="difference" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-orange-500"></div>
              <span className="text-sm font-semibold text-orange-500 uppercase tracking-wider">{content.difference.sectionSubtitle}</span>
            </div>
            <h3
              className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6"
              style={{ fontFamily: 'Playfair Display, serif' }}
              dangerouslySetInnerHTML={{ __html: content.difference.sectionTitleHtml }}
            />
            <div 
              className="text-lg text-gray-600 leading-relaxed mb-8 space-y-4"
              dangerouslySetInnerHTML={{ __html: content.difference.sectionDescription }}
            />
            <img
              src={content.difference.image}
              alt="Personalized Support"
              className="w-full h-64 object-cover object-top rounded-2xl"
            />
          </div>

          <div className="space-y-4">
            {content.difference.gaps.map((gap, i) => (
              <div key={i} className="flex items-start gap-4 p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 hover:bg-teal-50/30 transition-all duration-200">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className={`${gap.icon} text-xl text-teal-600`}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">{gap.title}</div>
                  <div className="text-gray-600 text-sm leading-relaxed">{gap.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
